/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * baseImgPath: 图片存放地址
 * 
 */
let baseUrl = '';
let baseImgPath;

if (process.env.NODE_ENV == 'development') {
	//开发环境
	baseUrl = '/api';
} else {
	//生产环境
	//本番测试： https://portal-wcf-dev.manecu.com/ 
	//本番正式：https://portal-wcf.manecu.com/ 
	//baseUrl = 'http://43.254.1.164:6058/'; //本地测试后台WCF的发布地址！！！
	//baseUrl = 'http://localhost:4273/';
	//baseUrl = 'http://portal-ws-dev.poplus.jp/'; //真实本番后台WCF的发布地址！！！
	baseUrl = 'https://portal-ws.poplus.jp/'; //真实本番后台WCF的发布地址！！！
	//baseImgPath = '//gis.rochotech.com:8016/img/';            

}

export {
	baseUrl,
	baseImgPath
}
